export const arrayArea = [
  'Contabilidade',
  'Fiscal',
  'Departamento Pessoal',
  'Recursos Humanos',
  'Faturamento Hospitalar',
  'Tecnologia',
  'Educação',
  'Auditoria',
  'Risco e Compliance'
]
